export const MEDIA_CONTENT_STATUS = {
  READY: 'ready', // Initialized and waiting for uploading.
  UPLOADING: 'uploading', // When complete -> uploaded.
  UPLOADED: 'uploaded', // Not approved, should not be seen.
  APPROVED: 'approved', // Can be seen on client.
  CANCELLED: 'cancelled', // A stop in the process.
};
